import { render } from "./MappingDetail.vue?vue&type=template&id=7a2db416&ts=true"
import script from "./MappingDetail.vue?vue&type=script&lang=ts"
export * from "./MappingDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__